module.exports = __webpack_public_path__ + "static/being-nixon-d01cfc19bf84ab5ed15601eba8068d49.jpg";